module.exports = __webpack_public_path__ + "static/img/Self-Adhesive Liquid Silocone Rubber.b1363d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/Self-Adhesive Liquid Silocone Rubber.jpg
// module id = 1QBK
// module chunks = 1